import { useTranslation } from 'react-i18next';
import { Button, Drawer } from '@/components';
import { WindProjectTechnology, ProjectTechnology, TechnologyCollection } from '@/features/projects/types';
import { WindFormNew } from './wind-form-new';

export type WindDrawerProps = {
  readonly formId: string;
  readonly technology: ProjectTechnology;
  readonly isOpen: boolean;
  readonly onSubmit: (collection: TechnologyCollection, item: WindProjectTechnology, description?: string) => void;
  readonly onClose: () => void;
};

export function WindDrawer({ formId, technology, isOpen, onSubmit, onClose }: WindDrawerProps) {
  const { t } = useTranslation(['projects']);
  const footer = (
    <>
      <Button size="lg" color="neutral" onClick={onClose}>
        {t('Cancel')}
      </Button>
      <Button type="submit" form={formId} size="lg" color="primary">
        {t('Save')}
      </Button>
    </>
  );

  return (
    <Drawer title={t('Wind Details & Design')} open={isOpen} onClose={onClose} footer={footer}>
      <WindFormNew
        id={formId}
        item={technology?.item as WindProjectTechnology}
        onSubmit={(data: any) =>
          onSubmit('projects_wind_technologies', { ...technology?.item, ...data }, t('Wind Details has been updated'))
        }
      />
    </Drawer>
  );
}
